import { RBTenantConfig } from 'src/tenantConfig/rbTenantConfig';
import { CAPSLTenantConfig } from './CAPSLTenantConfig';
import { MCAPSHelpTenantConfig } from 'src/tenantConfig/mcapsHelpPMConfig.ts';
import { MACCTenantConfig } from './MACCTenantConfig';
import { PMYTTenantConfig } from './PMYTTenantConfig';
import { ITenantUIConfig } from './interface';
import { ROBTenantConfig } from './RoBTenantConfig';
import { AOAITenantConfig } from './AOAITenantConfig';
import { CosellTenantConfig } from './CosellTenantConfig';
import { GPSTenantConfig } from './GPSTenantConfig';
import { ECIFTenantConfig } from './ECIFTenantConfig';
import { USMaaSTenantConfig } from './USMaaSTenantConfig';
import { AMMTenantConfig } from './AMMTenantConfig';
import { SGSTenantConfig } from './SGCITenantConfig';
import { GSITenantConfig } from './GSITenantConfig';
import { AzureISVTenantConfig } from './AzureISVTenantConfig';
import { MSFedTenantConfig } from './MSFedTenantConfig';
import { TechROBTenantConfig } from './TechROBTenantConfig';
import { UATConstants } from 'src/Common/Models/UATConstants';
import { nonAiCapacityIntakeConfig } from './nonAiCapacityIntakeConfig';
import { CompeteTenantConfig } from './CompeteTenantConfig';
import { PartnerSkillingTenantConfig } from './PartnerSkillingTenantConfig';
import { DefenderForCloudTenantConfig } from './DefenderForCloudTenantConfig';
import { MEATenantConfig } from './MEATenantConfig';
import { MicrosoftSecurityResearchTenantConfig } from './MicrosoftSecurityResearchTenantConfig';
import { MarketplaceTenantConfig } from './MarketplaceTenantConfig';

interface ITenantConfig {
  tenantId: string;
  newExperience: boolean;
  nodeName: string;
}

interface ILocalTenantConfigs {
  config: ITenantConfig[];
}

export const LocalTenantConfig: ILocalTenantConfig = {
  [UATConstants.TenantIds.RB]: RBTenantConfig,
  [UATConstants.TenantIds.CAPSL]: CAPSLTenantConfig,
  [UATConstants.TenantIds.MCAPS_HELP]: MCAPSHelpTenantConfig,
  [UATConstants.TenantIds.MACC]: MACCTenantConfig,
  [UATConstants.TenantIds.PMYT]: PMYTTenantConfig,
  [UATConstants.TenantIds.ROB]: ROBTenantConfig,
  [UATConstants.TenantIds.AOAI]: AOAITenantConfig,
  [UATConstants.TenantIds.GPS]: GPSTenantConfig,
  [UATConstants.TenantIds.COSELL]: CosellTenantConfig,
  [UATConstants.TenantIds.ECIF]: ECIFTenantConfig,
  [UATConstants.TenantIds.US_MAAS]: USMaaSTenantConfig,
  [UATConstants.TenantIds.AMM]: AMMTenantConfig,
  [UATConstants.TenantIds.SGS]: SGSTenantConfig,
  [UATConstants.TenantIds.GSI]: GSITenantConfig,
  [UATConstants.TenantIds.AZURE_ISV]: AzureISVTenantConfig,
  [UATConstants.TenantIds.TECH_ROB]: TechROBTenantConfig,  
  [UATConstants.TenantIds.COMPETE]: CompeteTenantConfig,
  [UATConstants.TenantIds.MS_FED]: MSFedTenantConfig,
  [UATConstants.TenantIds.NON_AI_CAPACITY_INTAKE]: nonAiCapacityIntakeConfig,
  [UATConstants.TenantIds.PS]: PartnerSkillingTenantConfig,
  [UATConstants.TenantIds.DEFENDER_FOR_CLOUD]: DefenderForCloudTenantConfig,
  [UATConstants.TenantIds.MEA]: MEATenantConfig,
  [UATConstants.TenantIds.MSR]: MicrosoftSecurityResearchTenantConfig,
  [UATConstants.TenantIds.MARKETPLACE]: MarketplaceTenantConfig,
};

const filterNewExperience = (config: Partial<ITenantUIConfig>) => {
  const { NewExperience, ...rest } = config;

  return NewExperience;
};

export const getFilteredTenantConfigs = (): ILocalTenantConfigs => {
  const filteredConfigs: ILocalTenantConfigs = { config: [] };

  for (const key in LocalTenantConfig) {
    if (LocalTenantConfig.hasOwnProperty(key)) {
      const nodeName = LocalTenantConfig[key]['nodeName'];
      const newExperience = filterNewExperience(LocalTenantConfig[key].FeatureConfig.ManageAction);
      const newObj = {
        tenantId: key,
        newExperience,
        nodeName: nodeName,
      };
      filteredConfigs.config.push(newObj);
    }
  }

  return filteredConfigs;
};

// Generated by GitHub Copilot | Updated on: 2026-01-16 | 3 lines modified | Added DefenderForCloudTenantConfig import and registration in LocalTenantConfig
// Generated by GitHub Copilot | Updated on: 2026-07-01 | 2 lines modified | Added MicrosoftSecurityResearchTenantConfig import and registration in LocalTenantConfig
// Generated by GitHub Copilot | Updated on: 2026-07-08 | 2 lines modified | Added MarketplaceTenantConfig import and registration in LocalTenantConfig
